import { Box, IconButton } from '@mui/material';
import './FundScreenerMenu.css';
import '../Common/typography.css';
import { ReactComponent as FilterIcon } from '../../assets/icons/filter.svg';
import { ReactComponent as RefreshIcon } from '../../assets/icons/refresh.svg';
import {
  AssetTypeItem,
  ClassificationItem,
  FundCriteria,
} from '../../types/fundScreener.type';
import SingleSelectCriterion from './Criteria/SingleSelectCriterion/SingleSelectCriterion';

interface FundScreenerMenuProps {
  isSmallScreen: boolean;
  assetTypes: AssetTypeItem[];
  setAssetTypes: (items: AssetTypeItem[]) => void;
  classifications: ClassificationItem[];
  setClassifications: (items: ClassificationItem[]) => void;
  criteria: FundCriteria[];
  setOpenAdvancedCriteria: (open: boolean) => void;
  setOpenSPAdvancedCriteria: (open: boolean) => void;
  onResetAll: () => void;
  onRefresh: () => void;
}

const FundScreenerMenu = ({
  isSmallScreen,
  assetTypes,
  setAssetTypes,
  classifications,
  setClassifications,
  criteria,
  setOpenAdvancedCriteria,
  setOpenSPAdvancedCriteria,
  onResetAll,
  onRefresh,
}: FundScreenerMenuProps) => {
  const selectedCount = criteria.filter((item) => item.selected).length;

  return (
    <Box className={`fund-screener-menu ${isSmallScreen ? 'small' : ''}`}>
      {!isSmallScreen && (
        <>
          <SingleSelectCriterion
            allLabel="All Asset types"
            items={assetTypes}
            setItems={setAssetTypes}
          />
          <SingleSelectCriterion
            allLabel="All Classifications"
            items={classifications}
            setItems={setClassifications}
            scrollable
          />
        </>
      )}

      <button
        type="button"
        className="fund-screener-menu-criteria-box body-m-regular"
        onClick={() =>
          isSmallScreen
            ? setOpenSPAdvancedCriteria(true)
            : setOpenAdvancedCriteria(true)
        }
      >
        <FilterIcon className="fund-screener-menu-criteria-icon" />
        <span className="fund-screener-menu-criteria-label">
          {isSmallScreen
            ? `All Filters (${selectedCount})`
            : `Screener Criteria (${selectedCount})`}
        </span>
      </button>

      <button
        type="button"
        className="fund-screener-menu-reset-all"
        onClick={onResetAll}
      >
        Reset all
      </button>

      <IconButton
        className="fund-screener-menu-refresh"
        sx={{
          boxSizing: 'border-box',
          width: '40px',
          height: '40px',
          flexShrink: 0,
          border: '1px solid var(--color-brand)',
          borderRadius: '4px',
          '&:hover': {
            backgroundColor: 'var(--color-brand-hover2)',
          },
        }}
        onClick={onRefresh}
      >
        <RefreshIcon />
      </IconButton>
    </Box>
  );
};

export default FundScreenerMenu;
